import { useState, useEffect } from 'react';

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero
      if (window.scrollY > 400) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isDismissed || !isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 z-50 animate-bounce-subtle">
      <div className="relative group">
        {/* Close button */}
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute -top-2 -right-2 w-6 h-6 bg-gray-800 border border-gray-600 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700 transition-all duration-200 z-10 opacity-0 group-hover:opacity-100"
          aria-label="Fechar"
        >
          <i className="ri-close-line text-xs"></i>
        </button>

        {/* CTA Button */}
        <a
          href="https://app.centraldamulta.app.br/register"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 px-5 py-3.5 bg-gradient-to-r from-yellow-500 to-amber-500 text-gray-900 rounded-full font-bold shadow-lg shadow-yellow-500/40 hover:shadow-xl hover:shadow-yellow-500/60 hover:scale-105 transition-all duration-300 overflow-hidden relative"
        >
          <span className="relative z-10 text-sm md:text-base whitespace-nowrap">🚀 Cadastre-se Grátis</span>
          <div className="relative z-10 w-7 h-7 bg-gray-900 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-yellow-400 text-sm"></i>
          </div>
          {/* Shine effect */}
          <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:left-[100%] transition-all duration-700"></div>
        </a>

        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-yellow-500 animate-ping opacity-20 pointer-events-none"></span>
      </div>
    </div>
  );
}
